import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Header() {
  const { user, logout } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="header">
      <h1 className="header-title">TaskMate</h1>
      <nav className="header-nav">
        <Link to="/">
          <button className={`nav-btn ${isActive('/') ? 'active' : ''}`}>Главная</button>
        </Link>
        <Link to="/tasks">
          <button className={`nav-btn ${isActive('/tasks') ? 'active' : ''}`}>Задачи</button>
        </Link>
        {user?.role !== 'employee' && (
          <Link to="/team">
            <button className={`nav-btn ${isActive('/team') ? 'active' : ''}`}>Команда</button>
          </Link>
        )}
        <Link to="/stats">
          <button className={`nav-btn ${isActive('/stats') ? 'active' : ''}`}>Статистика</button>
        </Link>
        {user?.role === 'admin' && (
          <Link to="/admin">
            <button className={`nav-btn ${isActive('/admin') ? 'active' : ''}`}>Админ</button>
          </Link>
        )}
        <button className="nav-btn" onClick={logout}>Выход</button>
      </nav>
    </header>
  );
}
